import { getAccessToken } from "../utils/storage";

import Axios from "../utils/http-request";
import { DashboardPropsData, GetSignaturesData } from "../interface/dashboard";

interface MetaData {
  current_page: number;
  last_page: number;
}

interface APIResponse<T> {
  data: T[];
  meta: MetaData;
}

interface PaginationParams {
  page: number;
  search: string;
  page_size: number;
}

export const apiGetInfinitePosts = async (
  pagination: PaginationParams
): Promise<{ data: APIResponse<DashboardPropsData> }> => {
  const { accessToken, tokenType } = await getAccessToken();
  const uri = `/posts?page=${pagination.page}&page_size=${pagination.page_size}&search=${pagination.search}`;
  const cfg = {
    headers: {
      Authorization: `${tokenType} ${accessToken}`,
    },
  };

  try {
    const result = await Axios.get<APIResponse<DashboardPropsData>>(uri, cfg);
    return { data: result.data }; // Successful response
  } catch (e: any) {
    console.error(e);
    // Return a consistent error shape
    return {
      data: {
        data: [],
        meta: { current_page: pagination.page, last_page: pagination.page },
      },
    };
  }
};

interface PaginationSignaturesParams {
  page: number;
  petition_id: number;
  page_size: number;
}
export const apiGetSignatures = async (
  pagination: PaginationSignaturesParams
): Promise<{ data: APIResponse<GetSignaturesData> }> => {
  const { accessToken, tokenType } = await getAccessToken();
  const uri = `/posts/petitions/${pagination.petition_id}/signatures?page=${pagination.page}&page_size=${pagination.page_size}`;
  const cfg = {
    headers: {
      Authorization: `${tokenType} ${accessToken}`,
    },
  };

  try {
    const result = await Axios.get<APIResponse<GetSignaturesData>>(uri, cfg);
    return { data: result.data }; // Successful response
  } catch (e: any) {
    console.error(e);
    // Return a consistent error shape
    return {
      data: {
        data: [],
        meta: { current_page: pagination.page, last_page: pagination.page },
      },
    };
  }
};
